import { EmployeeRequestService } from '@api/EmployeeRequestService';
import { useCallback, useState } from 'react';
import { invalidateOrgEmployeeRequestData } from '@stores/orgEmployeeRequestStore';

interface UseEmployeeRequestCommentResult {
    isPostingCommentInProgress: boolean;
    postComment: (requestId: string, comment: string) => Promise<void>;
    error?: string | undefined;
}

// TODO: Use useApiCall hook
const useEmployeeRequestComment = (
    departmentId: string | undefined,
    employeeId: string | undefined,
): UseEmployeeRequestCommentResult => {
    const [isPosting, setIsPosting] = useState<boolean>(false);
    const [error, setError] = useState<string>();

    const postComment = useCallback(
        async (requestId: string, comment: string) => {
            if (!departmentId || !employeeId) {
                return;
            }

            setIsPosting(true);
            setError(undefined);

            try {
                await EmployeeRequestService.putEmployeeRequestComment(
                    departmentId,
                    employeeId,
                    requestId,
                    { value: comment },
                );

                // The mutation changed request data — drop cached reads
                invalidateOrgEmployeeRequestData();
            } catch (err: unknown) {
                setError(
                    (err as Error)?.message ||
                        'Something went wrong while posting the comment.',
                );
            } finally {
                setIsPosting(false);
            }
        },
        [departmentId, employeeId],
    );

    return {
        isPostingCommentInProgress: isPosting,
        postComment,
        error,
    };
};

export default useEmployeeRequestComment;
